import React from "react";
import styles from "./AboutStoreIntegration.module.scss";
import Line from "./assets/bg.png";

const { header, texts, storeIn } = styles;
function StoreIntegration() {
  return (
    <section className={`${storeIn} global-lr-pad`}>
      <div className={header}>
        <h2>Store Integration</h2>
        <h1>We have best team and best process</h1>
        <p>
          Generate receipts for customers and guarantees to help users save
          money, Vendor will benefit from boosting productivity, by tracking
          inventory levels, orders, sales and deliveries.
        </p>
        <a href="/#">Get Started</a>
      </div>
      <div className={texts}>
        <img src={Line} alt="Line" />
        <div>
          <h1>Register your store</h1>
          <p>
            Register your store to boost revenue and have wequick pay user gain
            good service delivery.
          </p>
          <span>1</span>
        </div>
        <div>
          <h1>Complete your store setup</h1>
          <p>
            Access a range of tools to improve your inventory management and
            sales.
          </p>
          <span>2</span>
        </div>
        <div>
          <h1>Analitics, recipts, inovice, etc</h1>
          <p>Store managment at its best.</p>
          <span>3</span>
        </div>
      </div>
    </section>
  );
}

export default StoreIntegration;
